import { createAppAsyncThunk } from "core/src/store/store.types";
import { toast } from "react-toastify";

export enum ToastType {
	SUCCESS = "success",
	ERROR = "error",
	INFO = "info",
	WARN = "warn",
}

export type PostToastRequest = {
	type: ToastType
	message: string
};

export const postToast = createAppAsyncThunk<void, PostToastRequest>(
	"ui/postToast",
	(data) => {
		if (data.message === "Aborted due to condition callback returning false.") return;
		switch (data.type) {
			case ToastType.SUCCESS:
				toast.success(data.message);
				break;
			case ToastType.ERROR:
				toast.error(data.message);
				break;
			case ToastType.INFO:
				toast.info(data.message);
				break;
			case ToastType.WARN:
				toast.warn(data.message);
				break;
			default:
				break;
		}
	}
);
